// RBC 22-sep-2026 — UX movil ficha de producto.
// Cambios frente a la version anterior:
//  1. Ya NO se preselecciona talla. Antes se marcaba XS (o XS/XS en conjuntos) y, si esa
//     combinacion estaba agotada, lo primero que veia el cliente era "Agotado" + boton gris.
//     Ahora el CTA dice "Elige tu talla" y al pulsarlo resalta el selector.
//  2. Conjuntos: las tallas se filtran de forma cruzada. Al elegir short S se tachan las
//     tallas de rashguard que no tienen stock con short S. Si se pulsa una talla tachada que
//     SI tiene stock con otra talla del otro grupo, se suelta la seleccion del otro grupo.
//  3. Boton fijo movil: se muestra siempre que el selector y el CTA no esten en pantalla.
//     Si ya hay talla valida pasa a "Anadir al carrito · precio" y anade directamente.
//  4. body.rbc-sticky-on mientras el boton fijo esta visible (el CSS sube el chat).
document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.prc-container');
  if (!container) return;

  const ds = container.dataset;
  const currency = ds.currency || 'EUR';
  const locale = ds.locale || 'es-ES';
  const variants = JSON.parse(ds.variants || '[]');
  const priceDisplays = document.querySelectorAll('.prc-price');
  const KLAVIYO_BIS_FORM = 'R8Kaz2';
  const LOW_STOCK_THRESHOLD = 3;
  const isMobile = () => window.innerWidth <= 768;

  const T = {
    chooseSize: ds.i18nChooseSize || 'Elige tu talla',
    chooseSizes: ds.i18nChooseSizes || 'Elige tus tallas',
    comboOut: ds.i18nComboOut || 'Combinaci\u00f3n agotada \u00b7 prueba otra talla',
    addToCart: ds.i18nAddToCart || 'A\u00f1adir al carrito',
    soldOut: ds.i18nSoldOut || 'Agotado',
    lowStock: ds.i18nLowStockShort || 'Pocas unidades',
    notify: ds.i18nNotify || '&#128276; Av&iacute;same cuando est&eacute; disponible',
    sizeOut: ds.i18nSizeOut || 'Talla agotada'
  };

  function formatMoney(cents) {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
  }

  // ── ESTADO DE TALLAS ──
  const sizeBtns = Array.from(container.querySelectorAll('.prc-size-btn'));
  const grids = Array.from(container.querySelectorAll('.prc-size-grid'));
  const statusEls = Array.from(container.querySelectorAll('.prc-stock-status'));
  const variantInput = document.querySelector('.prc-variant-input-desktop');
  const ctaSingle = document.querySelector('.prc-cta-single');
  const ctaSplit = document.querySelector('.prc-cta-split');
  const placeholderBtn = ctaSingle ? ctaSingle.querySelector('.prc-cta-placeholder') : null;
  const sizesSection = document.getElementById('prc-sizes-section');
  const ctaBlock = document.getElementById('prc-cta-block');
  const selected = {};
  const groups = [...new Set(sizeBtns.map(b => parseInt(b.dataset.optionIndex, 10)))];
  const isBundle = groups.length > 1;
  let currentVariant = null;

  const isAvail = v => (typeof v.available === 'boolean') ? v.available : !!v.availableForSale;
  const inv = v => v.inventory_quantity ?? v.inventoryQuantity ?? 0;
  const allChosen = () => groups.every(i => selected[i] !== undefined);
  const findVariant = () => allChosen()
    ? (variants.find(v => groups.every(i => v.options[i] === selected[i])) || null)
    : null;

  // Variantes compatibles con una talla dada y con lo ya elegido en los OTROS grupos.
  function compatible(idx, val) {
    return variants.filter(v => v.options[idx] === val &&
      groups.every(j => j === idx || selected[j] === undefined || v.options[j] === selected[j]));
  }
  function valueHasAnyStock(idx, val) {
    return variants.some(v => v.options[idx] === val && isAvail(v));
  }

  function refreshButtons() {
    sizeBtns.forEach(btn => {
      const idx = parseInt(btn.dataset.optionIndex, 10);
      const val = btn.dataset.optionValue;
      const avail = compatible(idx, val).filter(isAvail);
      const n = avail.reduce((m, v) => Math.max(m, inv(v)), 0);
      btn.classList.toggle('sold-out', avail.length === 0);
      btn.dataset.inventory = n;
      btn.classList.toggle('low-stock', avail.length > 0 && n > 0 && n <= LOW_STOCK_THRESHOLD);
      btn.classList.toggle('active', selected[idx] === val);
      btn.setAttribute('aria-pressed', selected[idx] === val ? 'true' : 'false');
    });
  }

  function setStatus(idx, text, cls) {
    const el = statusEls[groups.indexOf(idx)] || statusEls[0];
    if (!el) return;
    el.textContent = text;
    el.className = 'prc-stock-status ' + cls;
  }
  function clearStatus() {
    statusEls.forEach(el => { el.textContent = ''; el.className = 'prc-stock-status'; });
  }

  // ── KLAVIYO BIS (solo productos simples) ──
  window.prcOpenBIS = function(variantId) {
    window.klaviyoVariantId = variantId;
    window._klBISVariantId = variantId;
    function tryOpen() {
      if (window._klOnsite?.openForm) { window._klOnsite.openForm(KLAVIYO_BIS_FORM); return true; }
      if (window.klaviyo?.openForm) { window.klaviyo.openForm(KLAVIYO_BIS_FORM); return true; }
      return false;
    }
    if (!tryOpen()) {
      var attempts = 0;
      var iv = setInterval(function() { if (tryOpen() || ++attempts > 20) clearInterval(iv); }, 300);
    }
  };

  function showNotify(variant) {
    if (ctaSingle) ctaSingle.style.display = 'none';
    if (ctaSplit) ctaSplit.style.display = 'none';
    let wrap = document.getElementById('prc-notify-wrap');
    if (!wrap) {
      wrap = document.createElement('div'); wrap.id = 'prc-notify-wrap';
      ctaBlock?.appendChild(wrap);
    }
    wrap.innerHTML = `<button class="prc-notify-btn" type="button" onclick="window.prcOpenBIS('${variant.id}')">${T.notify}</button><p class="prc-notify-label">${T.sizeOut}</p>`;
    wrap.style.display = 'block';
  }
  function hideNotify() {
    const w = document.getElementById('prc-notify-wrap');
    if (w) w.style.display = 'none';
  }

  function showPlaceholder(text, mode) {
    hideNotify();
    if (ctaSplit) ctaSplit.style.display = 'none';
    if (ctaSingle) ctaSingle.style.display = 'block';
    if (placeholderBtn) { placeholderBtn.textContent = text; placeholderBtn.dataset.mode = mode; }
  }

  // Lleva al selector y resalta los grupos sin elegir (o todos si la combinacion no existe).
  function flagMissing() {
    const missing = grids.filter((g, k) => selected[groups[k]] === undefined);
    const list = missing.length ? missing : grids;
    sizesSection?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    list.forEach(g => { g.classList.remove('prc-attn'); void g.offsetWidth; g.classList.add('prc-attn'); });
  }
  placeholderBtn?.addEventListener('click', flagMissing);

  function render(lastIdx) {
    refreshButtons();
    clearStatus();
    hideNotify();
    currentVariant = null;
    if (variantInput) variantInput.value = '';

    if (!allChosen()) {
      showPlaceholder(isBundle ? T.chooseSizes : T.chooseSize, 'choose');
      syncFooter();
      return;
    }

    const v = findVariant();
    if (!v || !isAvail(v)) {
      setStatus(lastIdx, T.soldOut, 'out-of-stock');
      if (!isBundle && v) showNotify(v);
      else showPlaceholder(T.comboOut, 'unavailable');
      syncFooter();
      return;
    }

    currentVariant = v;
    priceDisplays.forEach(el => el.textContent = formatMoney(v.price));
    if (variantInput) variantInput.value = v.id;
    const n = inv(v);
    if (n > 0 && n <= LOW_STOCK_THRESHOLD) setStatus(lastIdx, T.lowStock, 'low-stock');
    if (ctaSingle) ctaSingle.style.display = 'none';
    if (ctaSplit) ctaSplit.style.display = 'flex';
    syncFooter();
  }

  sizeBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const idx = parseInt(this.dataset.optionIndex, 10);
      const val = this.dataset.optionValue;
      if (isBundle && this.classList.contains('sold-out') && valueHasAnyStock(idx, val)) {
        groups.forEach(j => { if (j !== idx) delete selected[j]; });
      }
      selected[idx] = val;
      render(idx);
    });
  });

  // ── BOTON FIJO MOVIL ──
  const footer = document.getElementById('prc-mobile-footer');
  const footerBtn = document.getElementById('prc-footer-choose-size-btn');
  const inView = { sizes: false, cta: false };

  function syncFooter() {
    if (!footer || !footerBtn) return;
    if (currentVariant) {
      footerBtn.textContent = T.addToCart + ' \u00b7 ' + formatMoney(currentVariant.price);
      footerBtn.dataset.mode = 'add';
    } else {
      footerBtn.textContent = isBundle ? T.chooseSizes : T.chooseSize;
      footerBtn.dataset.mode = 'choose';
    }
    const show = isMobile() && !inView.sizes && !inView.cta;
    footer.classList.toggle('is-hidden', !show);
    document.body.classList.toggle('rbc-sticky-on', show);
  }

  if (footer && footerBtn) {
    document.body.classList.add('rbc-pdp');
    footerBtn.addEventListener('click', function() {
      if (footerBtn.dataset.mode === 'add' && currentVariant) addToCartAjax(currentVariant.id, footerBtn);
      else flagMissing();
    });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.target === sizesSection) inView.sizes = e.isIntersecting;
          if (e.target === ctaBlock) inView.cta = e.isIntersecting;
        });
        syncFooter();
      }, { threshold: 0 });
      if (sizesSection) io.observe(sizesSection);
      if (ctaBlock) io.observe(ctaBlock);
    }
    window.addEventListener('resize', syncFooter);
  }

  // Estado inicial: sin talla elegida, salvo grupos de un solo valor (talla unica).
  sizeBtns.forEach(b => b.classList.remove('active'));
  groups.forEach(idx => {
    const btns = sizeBtns.filter(b => parseInt(b.dataset.optionIndex, 10) === idx);
    if (btns.length === 1) selected[idx] = btns[0].dataset.optionValue;
  });
  render(groups[0]);

  // ── FORM ──
  const formDesktop = document.querySelector('.prc-form-desktop');
  if (formDesktop) {
    formDesktop.addEventListener('submit', e => {
      e.preventDefault();
      addToCartAjax(variantInput?.value, formDesktop.querySelector('.prc-btn-atc'));
    });
  }

  // ── POPUP (tabs) ──
  const popupOverlay = document.getElementById('prc-popup');
  const popupTitle = document.getElementById('prc-popup-title');
  const popupBody = document.getElementById('prc-popup-body');
  const popupContent = {
    'details':  { title: ds.i18nTitleDetails || 'Detalles',        body: ds.details  || '' },
    'size-fit': { title: ds.i18nTitleSize || 'Gu\u00eda de tallas', body: ds.sizeFit  || '' },
    'shipping': { title: ds.i18nTitleShipping || 'Env\u00edos',     body: ds.shipping || '' }
  };

  function closePopup() {
    popupOverlay?.classList.remove('active');
    document.body.style.overflow = '';
  }

  container.querySelectorAll('.prc-tab').forEach(tab => {
    tab.addEventListener('click', function() {
      const content = popupContent[this.dataset.tab];
      if (!content) return;
      popupTitle.innerHTML = content.title;
      popupBody.innerHTML = content.body;
      popupOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });
  document.getElementById('prc-popup-close')?.addEventListener('click', closePopup);
  popupOverlay?.addEventListener('click', e => { if (e.target === popupOverlay) closePopup(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closePopup(); });
  window.addEventListener('pageshow', () => { if (!popupOverlay?.classList.contains('active')) document.body.style.overflow = ''; });

  // ── GUIA DE TALLAS JUNTO AL SELECTOR ──
  (function initInlineSizeGuide() {
    const labelRow = container.querySelector('.prc-size-label-row');
    const sizeFitTab = container.querySelector('.prc-tab[data-tab="size-fit"]');
    const hasContent = (ds.sizeFit || '').trim().length > 0;
    if (!labelRow || !sizeFitTab || !hasContent) return;

    const style = document.createElement('style');
    style.textContent = `
      .prc-size-guide-inline {
        background: none; border: none; padding: 0; margin: 0 0 0 auto;
        font-family: inherit; font-size: 11px; text-transform: uppercase;
        letter-spacing: 0.8px; color: #8A8A8A; cursor: pointer;
        display: inline-flex; align-items: center; gap: 5px;
        border-bottom: 1px solid #D6CFC4; border-radius: 0;
        transition: color 0.2s ease, border-color 0.2s ease;
      }
      .prc-size-guide-inline:hover { color: #C2A572; border-bottom-color: #C2A572; }
      .prc-size-guide-inline svg { flex-shrink: 0; }
      .prc-size-label-row .prc-stock-status { margin-left: 12px; }
      @media (max-width: 768px) { .prc-size-guide-inline { font-size: 10.5px; padding: 6px 0; } }
    `;
    document.head.appendChild(style);

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'prc-size-guide-inline';
    btn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 14l12-12 8 8-12 12z"/><path d="M7 7l2 2"/><path d="M11 3l2 2"/><path d="M4 11l2 2"/></svg>' + popupContent['size-fit'].title;
    btn.addEventListener('click', () => sizeFitTab.click());

    const stock = labelRow.querySelector('.prc-stock-status');
    if (stock) labelRow.insertBefore(btn, stock);
    else labelRow.appendChild(btn);

    sizeFitTab.style.display = 'none';
  })();

  // ── CAROUSEL ──
  const track = container.querySelector('.prc-carousel-track');
  const dots = container.querySelectorAll('.prc-dot');
  if (track && dots.length) {
    let currentIdx = 0, startX = 0, startY = 0, dragging = false;
    track.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dragging = true;
    }, { passive: true });
    track.addEventListener('touchmove', e => {
      if (!dragging) return;
      const dx = startX - e.touches[0].clientX;
      const dy = startY - e.touches[0].clientY;
      if (Math.abs(dy) > Math.abs(dx)) { dragging = false; return; }
      if (Math.abs(dx) > 50) { currentIdx = dx > 0 ? Math.min(currentIdx+1, dots.length-1) : Math.max(currentIdx-1, 0); updateCarousel(); dragging = false; }
    }, { passive: true });
    track.addEventListener('touchend', () => { dragging = false; });
    track.addEventListener('touchcancel', () => { dragging = false; });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { currentIdx = i; updateCarousel(); }));
    container.querySelector('.prc-carousel-prev')?.addEventListener('click', () => { currentIdx = Math.max(currentIdx-1, 0); updateCarousel(); });
    container.querySelector('.prc-carousel-next')?.addEventListener('click', () => { currentIdx = Math.min(currentIdx+1, dots.length-1); updateCarousel(); });
    function updateCarousel() {
      track.style.transform = `translateX(-${currentIdx * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle('active', i === currentIdx));
    }
  }

  // ── CART ──
  function updateCartCount(count) {
    document.querySelectorAll('.cart-count-bubble').forEach(el => {
      el.innerHTML = `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items</span>`;
      el.classList.remove('hidden');
    });
  }

  function refreshCartBubble(sections) {
    const target = document.getElementById('cart-icon-bubble');
    const html = sections && sections['cart-icon-bubble'];
    if (target && html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('shopify-section-cart-icon-bubble') || doc.querySelector('.shopify-section');
      if (fresh) { target.innerHTML = fresh.innerHTML; return; }
    }
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => updateCartCount(cart.item_count))
      .catch(err => console.error('PRC bubble error:', err));
  }

  function addToCartAjax(variantId, btn) {
    if (!variantId) return;
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    })
    .then(r => r.json())
    .then(data => {
      if (data.status && !data.sections) {
        // p. ej. 422: no hay mas stock de esa variante
        setStatus(groups[0], data.description || data.message || T.soldOut, 'out-of-stock');
        return;
      }
      if (data.sections?.['cart-drawer']) {
        const doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
        const nD = doc.getElementById('CartDrawer'), cD = document.getElementById('CartDrawer');
        if (nD && cD) cD.innerHTML = nD.innerHTML;
        else { const n = doc.querySelector('cart-drawer'), c = document.querySelector('cart-drawer'); if (n && c) c.innerHTML = n.innerHTML; }
        const drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) { drawerEl.classList.remove('is-empty'); drawerEl.open(); }
        document.querySelector('.drawer__inner')?.classList.remove('is-empty');
      }
      refreshCartBubble(data.sections);
    })
    .catch(err => console.error('PRC cart error:', err))
    .finally(() => { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  }
});
